import { c as _c } from "react/compiler-runtime";
import { closeIcon } from '@/uiIcons/closeIcon.css';
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { focusBox } from '@/uiPrimitives/base/focus.css';
import { box } from '@/uiPrimitives/layout/box';
import { position } from '@/uiPrimitives/layout/position';
import { zIndex } from '@/uiPrimitives/layout/zIndex.css';
import { icon } from '@/uiPrimitives/media/icon';
import { addTestSelector } from '@/globals/testHelpers/testSelector';
import { ComponentPropsWithoutRef } from 'react';
import { pile } from '@/uiPrimitives/layout/pile';
import { translateInline } from '@/globals/translate/translateInline';
export const ClosePopup = t0 => {
  const $ = _c(11);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = classes(className, zIndex({
      zIndex: "1"
    }), box({
      backgroundColor: "positiveBlue",
      inlineSize: "3 | h1",
      blockSize: "3 | h1"
    }), pile({
      alignItems: "center",
      justifyItems: "center"
    }), position({
      position: "absolute",
      insetInlineEnd: "0",
      insetBlockStart: "0"
    }), focusBox);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  let t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = translateInline({
      en: "Close Feedback Popup",
      nl: "Sluit feedback-popup"
    });
    t3 = addTestSelector("uiCloseFeedbackPopupButton");
    t4 = <i className={classes(icon({
      icon: closeIcon,
      inlineSize: "-1 | small",
      blockSize: "-1 | small"
    }))} />;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  if ($[8] !== props || $[9] !== t1) {
    t5 = <button {...props} className={t1} aria-label={t2} {...t3}>{t4}</button>;
    $[8] = props;
    $[9] = t1;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};